module.exports = __webpack_public_path__ + "static/img/gg.433ff18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/gg.png
// module id = qXUB
// module chunks = 0